<div class="full-page">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="panel rounded">
          <fgbcl-errors></fgbcl-errors>
          @if (loading) {
            <p *ngIf="loading" class="text-center my-3">
              <i>{{ 'mlbam.account.loading' | translate: { fgbdefault: 'Loading your accounts...' } }}</i>
            </p>
          }
        </div>
      </div>
    </div>
  </div>
</div>
